import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ApiService } from "../../../services/api.service";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { FormHelper } from "../../../helpers/form.helper";
import { IonicHelper } from "../../../helpers/ionic.helper";
import { UserGroupService } from "../../../services/user-group.service";
import { FormValidators } from "../../../form/form.validators";
import { AuthService } from "../../../services/auth.service";
import { UserInvite } from '../../../app/app.interfaces';

@Component({
	selector: 'admin-user-create',
	templateUrl: 'admin-user-create.html'
})


export class AdminUserCreate implements OnInit {

  @Output() create: EventEmitter<UserInvite> = new EventEmitter<UserInvite>();
  
	form: FormGroup;
	edit: boolean = false;

	constructor( private apiService: ApiService,
							 private ionic: IonicHelper,
							 private formBuilder: FormBuilder,
							 private authService: AuthService,
							 private userGroupService: UserGroupService){


	}


	ngOnInit(): void {

		this.buildUserInviteForm().then((form) => {
			this.form = form;
		});
	}
	
	toggleEdit(edit: boolean = null){
		if(edit===null) edit = !(this.edit);
		this.edit = edit;
	}

	buildUserInviteForm(): Promise<FormGroup> {

		return new Promise<FormGroup>((resolve) => {

			let form = this.formBuilder.group({
				firstName: ['', Validators.compose([Validators.minLength(3), Validators.maxLength(100)])],
				lastName: ['', Validators.compose([Validators.minLength(3), Validators.maxLength(100)])],
				email: ['', Validators.compose([Validators.maxLength(60), Validators.email, Validators.required])],
				userGroup: ['', Validators.compose([Validators.required])]
			});

			resolve(form);

		});
	}


	submitForm(): void {
		this.ionic.toggleLoader(true);

		if(this.form.valid){
			this.ionic.toggleLoader(false);
						
			let userInvite = this.form.value;
			
			this.apiService.createResource('user_invites', userInvite).then((userInvite: UserInvite) => {								
        
				this.ionic.toggleLoader(false);
				if (!userInvite.fullName) {
				  userInvite.fullName = userInvite.firstName + ' ' + userInvite.lastName;
        }
        this.create.emit(userInvite);
	      this.ionic.toast('ADMIN.SEND_INVITE_TOAST');
	      
        this.form.reset();
        this.edit = false;

			}).catch((err) => {
				console.error(err);
			  this.ionic.toggleLoader(false);
	      
	      let errMsg = 'GLOBAL.GENERAL_ERROR';
	      
	      if(err.data && err.data['hydra:description']){
	        if(err.data['hydra:description'] === 'EXISTING_INVITE'){
	          errMsg = 'ADMIN.SEND_INVITE_ERR_EXISTING_INVITE';	          
          }
          else if(err.data['hydra:description'] === 'EXISTING_USER'){
	          errMsg = 'ADMIN.SEND_INVITE_ERR_EXISTING_USER';	          
          }
        }
        
	      this.ionic.alert(errMsg);
	      
			});
			

			// this.form.reset();
			// this.edit = false;
		}
		else{
			this.ionic.toggleLoader(false);
			this.ionic.invalidFieldsAlert(
				'ADMIN.USER_CREATE_ERROR',
				'POST_CREATE.TRY_AGAIN',
				'ACCEPT_INVITE.ERRORS',
				FormHelper.getInvalidFormControls(this.form.controls)
			);
		}
	}


}



// WEBPACK FOOTER //
// ./src/partials/admin/admin-user-create/admin-user-create.ts